import { render, staticRenderFns } from "./InventoryTransactionModal.vue?vue&type=template&id=00245886&scoped=true&"
import script from "./InventoryTransactionModal.vue?vue&type=script&lang=js&"
export * from "./InventoryTransactionModal.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTransactionModal.vue?vue&type=style&index=0&id=00245886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00245886",
  null
  
)

export default component.exports